export const types = {
  if_necessary: 'Se necessário',
  urgent: 'Urgente',
  doctor_discretion: 'Critério do médico',
};

export function getName(value) {
  return types[value];
}
